<!-- @Deprecated!!! -->

<div class="button-container">
  <div class="search">
    <input type="text" />
    <i (click)="search()" (keypress)="search()" class="material-icons">search</i>
  </div>
  <button class="align-right" mat-flat-button color="primary" (click)="newAssessment()">Neue Testung</button>
</div>
<table mat-table [dataSource]="assessmentList()" class="mat-elevation-z8" aria-label="Assessment Liste">
  <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>Zeitpunkt</th>
    <td mat-cell *matCellDef="let element">
      {{ element.dateIso | date: 'fullDate' }}, {{ element.dateIso | date: 'shortTime' }}
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Befundung</th>
    <td mat-cell *matCellDef="let element">{{ element.type }}</td>
  </ng-container>
  <ng-container matColumnDef="score">
    <th class="center" mat-header-cell *matHeaderCellDef>Score</th>

    <td class="center" mat-cell *matCellDef="let element">
      @if ((element | assessmentScore) === 8) {
        <mat-progress-bar mode="buffer"></mat-progress-bar>
      } @else {
        {{ element | assessmentScore }}
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="note">
    <th mat-header-cell *matHeaderCellDef>Zusätzliche Hinweise</th>
    <td class="note" mat-cell *matCellDef="let element">{{ element | assessmentNotes }}</td>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let assessment">
      <div class="buttons">
        <button (click)="navigateToAssessment(assessment)" mat-button color="basic">
          <span class="uppercase small">Bearbeiten</span>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="deleteAssessment(assessment)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Löschen</span>
          </button>
        </mat-menu>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
</table>
